module.exports = require("fbemitter");


//////////////////
// WEBPACK FOOTER
// external "fbemitter"
// module id = 103
// module chunks = 0 1 2